import { createStore } from "vuex"

const UserInfo = localStorage.getItem("userData")
const schoolInfo = localStorage.getItem("schoolInfo")
const topIds = localStorage.getItem("topIds")
export default createStore({
  state: {
    wxLogin: false,
    bindPhone: false,
    schoolInfo: schoolInfo ? JSON.parse(schoolInfo) : "", // 学校信息
    userInfo: UserInfo ? JSON.parse(UserInfo) : {}, // 用户信息
    topIds: topIds ? topIds.split(",") : [], //置顶课程ids
  },
  mutations: {
    changeWxLogin(state, status) {
      state.wxLogin = status
    },
    changeBindPhone(state, status) {
      state.bindPhone = status
    },
    saveSchoolInfo(state, data) {
      state.schoolInfo = data
      localStorage.setItem("schoolInfo", JSON.stringify(data))
    },
    setUserInfo(state, data) {
      state.userInfo = data
      localStorage.setItem("userData", JSON.stringify(data))
    },
    clearUserInfo(state) {
      state.userInfo = {}
      localStorage.removeItem("userData")
    },
    setTopIds(state, data) {
      if (!state.topIds.includes(data)) {
        state.topIds = state.topIds.push(data)
        localStorage.setItem("topIds", state.topIds.join(","))
      }
    },
  },
  actions: {},
})
